import { render, staticRenderFns } from "./OfficeCardNeed.vue?vue&type=template&id=4b6ec555&scoped=true&"
import script from "./OfficeCardNeed.vue?vue&type=script&lang=js&"
export * from "./OfficeCardNeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6ec555",
  null
  
)

export default component.exports